import * as _ from 'lodash';
import Reflux from 'reflux';
import RefluxPromise from 'reflux-promise';

import { get, put } from '../redux/api';
import { nuc } from '../utils';

//  Allows Reflux actions to return promises (similar to redux-promise).
Reflux.use(RefluxPromise(Promise));

const ProjectActions = Reflux.createActions({
  // New data is applied to the store
  update: {},

  // Fetch update from server and apply
  load: {
    children: [
      'started',
      'completed', // also triggers a `ProjectActions.update` in `ProjectStore`
      'failed',
    ],
  },

  pushUpdate: {
    children: ['started', 'completed', 'failed'],
  },

  fetchLatest: {},
});

ProjectActions.load.listen((id, paramOptions) => {
  const options = _.assignIn(
    {
      sort: null,
    },
    paramOptions,
  );
  ProjectActions.load.started(id, options);
  get(`/api/projects/${nuc(id)}`, false, _.pick(options, 'ref_type', 'ref', 'badge_ref'), {
    encodeQuery: true, // ref may contain slashes and other special characters
  })
    .then(resp => {
      ProjectActions.load.completed(id, resp.data);
      return resp.data;
    })
    .catch(err => {
      ProjectActions.load.failed(id, err.data);
      return err;
    });
});

ProjectActions.pushUpdate.listen((locator, data, query) => {
  ProjectActions.pushUpdate.started(locator, data);
  // In order for these list attributes to be updated when the new list is empty,
  // they need to be passed as empty strings in the req body.
  if (data.transitive_excludes?.length === 0) {
    data.transitive_excludes = '';
  }
  if (data.tracking_branches?.length === 0) {
    data.tracking_branches = '';
  }
  if (data.hidden_branches?.length === 0) {
    data.hidden_branches = '';
  }
  if (data.notifications?.length === 0) {
    data.notifications = [''];
  }
  if (data.bom_column_settings?.length === 0) {
    data.bom_column_settings = '';
  }
  if (data.issueTrackerLabels?.length === 0) {
    data.issueTrackerLabels = '';
  }
  if (data.issueTrackerIssueTypes?.length === 0) {
    data.issueTrackerIssueTypes = '';
  }
  if (data.labels) {
    // Convert list of Label objects to list of ids
    data.labels = data.labels.map((value) => value.id);
  }

  return put(
    `/api/projects/${nuc(locator)}`,
    data,
    { query },
  )
    .then(response => {
      ProjectActions.pushUpdate.completed(locator, response.data);
      return response.data;
    })
    .catch(err => {
      ProjectActions.pushUpdate.failed(locator, err.data);
      throw new Error(err.data);
    });
});

export default ProjectActions;
